import { format } from "date-fns";
import { CurrencyFormat } from "../../CurrencyFormat";
import styles from "./transaction-row.module.scss";
import { Transaction } from "./types";

interface Props {
  transaction: Transaction;
  index: number;
}
export const TransactionRow = ({ transaction, index }: Props) => (
  <div
    className={`${styles.transaction}
                    ${transaction.type === "CREDIT" ? styles.credit : ""}`}
    key={index}
    role="row"
  >
    <div className={styles.description} role="cell">
      {transaction.description} <br />
      {transaction.status === "PENDING" && (
        <span className={`body02 ${styles.date}`}>
          {format(new Date(transaction.transaction_date), "dd MMM yyyy")}
          <br />
        </span>
      )}
    </div>
    <div className={styles.amount} role="cell">
      {transaction.type === "CREDIT" ? "+" : "-"}
      <CurrencyFormat value={transaction.amount} />
    </div>
  </div>
);
